import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-document',
  templateUrl: './icon-document.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconDocumentComponent {}
